// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Field__Component__Label__Date > div[data-v-7480e5c2] {\n  width: 100%;\n  margin: 15px 5px;\n}\n.Field__Component__Label__Date > div[data-v-7480e5c2]:first-of-type {\n    margin-right: 0;\n}\n.Field__Component__Label__Date > div[data-v-7480e5c2]:last-of-type {\n    margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
